(() => {
  if (window.__eldraKlarnaRataBound) return;
  window.__eldraKlarnaRataBound = true;

  const formatMoney = (cents, format) => {
    const value = (Number(cents) || 0) / 100;
    const fmt = format || '{{amount}}';
    const withComma = value.toFixed(2).replace('.', ',');
    const withDot = value.toFixed(2);
    return String(fmt)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(value)).replace('.', ','))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withDot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value)))
      .replace(/\{\{\s*amount\s*\}\}/g, withDot)
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, withDot);
  };

  const refreshNode = (node, amountCents) => {
    if (!node) return;
    const installments = Math.max(2, Number(node.dataset.installments) || 3);
    const min = Number(node.dataset.min) || 0;
    const amount = Number(amountCents);
    const show = Number.isFinite(amount) && amount > 0 && amount >= min;
    node.hidden = !show;
    if (!show) return;

    node.dataset.amount = String(Math.round(amount));
    const rata = Math.floor(amount / installments);
    const money = formatMoney(rata, node.dataset.moneyFormat);
    const tpl = node.dataset.lineTpl || 'da {{ amount }} in {{ count }} rate';
    const line = tpl
      .replace(/\{\{\s*count\s*\}\}/g, String(installments))
      .replace(/\{\{\s*amount\s*\}\}/g, money);
    const lineEl = node.querySelector('[data-eldra-klarna-line]');
    if (lineEl) lineEl.textContent = line;
  };

  const updateCartNodes = (amountCents) => {
    document.querySelectorAll('[data-eldra-klarna-rata][data-context^="cart"]').forEach((node) => {
      refreshNode(node, amountCents);
    });
  };

  const updateProductNodes = (amountCents) => {
    document.querySelectorAll('[data-eldra-klarna-rata][data-context="product"]').forEach((node) => {
      refreshNode(node, amountCents);
    });
  };

  window.EldraKlarnaRata = {
    refreshNode,
    updateCart: updateCartNodes,
    updateProduct: updateProductNodes,
  };

  const bindVariantChange = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event && event.data && event.data.variant;
      if (!variant || variant.price == null) return;
      updateProductNodes(variant.price);
    });
    if (PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cart = event && event.data && event.data.cartData;
        if (!cart || cart.total_price == null) return;
        const amount = cart.items && cart.items.length > 0 ? cart.total_price : 0;
        updateCartNodes(amount);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindVariantChange, { once: true });
  } else {
    bindVariantChange();
  }
})();
